export function getProductField(field: any, override: any): any {
	return override === undefined ? field : override;
}
